<template>
<div class="cell">
  <b-progress :value="params.value" show-progress max="'100'"></b-progress>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.cell {
  height: 100%;
  display: flex;
  align-items: center;
  & > div {
    width: 100%;
    height: 2rem;
  }
}
</style>
